import { render } from "./resDetail.vue?vue&type=template&id=2efbf8bb&scoped=true"
import script from "./resDetail.vue?vue&type=script&lang=js"
export * from "./resDetail.vue?vue&type=script&lang=js"

import "./resDetail.vue?vue&type=style&index=0&id=2efbf8bb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e16590e957a4dff7099c04c4dde027e6/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2efbf8bb"]])

export default __exports__